import { useApplicationContext } from 'shared/serp/containers/ApplicationContext';

export function useGetIsElectronicTrading(): boolean {
  const { config } = useApplicationContext();

  /**
   * @todo Удалить фича-тогл
   * @description Данный функционал появился в задаче CD-198059, будет удалён в задаче CD-198513
   */
  const isElectronicTradingEnabled = config.getStrict<boolean>('Commercial.ElectronicTrading.Enabled');

  /**
   * TODO: добавить имплементацию для значения "true", когда будет согласован контракт с бэком
   */
  return isElectronicTradingEnabled && true;
}
